<template>
  <div class="member-activity-room">
    <default />
  </div>
</template>

<script>
export default {
  components: {
    default: () => import('@t/activityRoom/default')
  },
  beforeRouteEnter(to, from, next) {
    if (from.path != '/activityRoomDetails') {
      localStorage.removeItem('activityRoomIndex')
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
.member-activity-room {
  height: 100%;
}
</style>
